import Footer from "./Footer";
import Logo from "./Logo";
import PropTypes from "prop-types";
import useEnv from "../hooks/useEnv";
import useUserAccount from "../hooks/useUserAccount";
import { Link } from "react-router-dom";

const LandingFooter = ({ locale }) => {
    const { isEnvTruthy } = useEnv();
    const { personalAuthLink, companyAuthLink } = useUserAccount();

    const signInButtonsElement = <>
        <Link
            className="btn btn-personal-sign-in"
            to={personalAuthLink}
            aria-label={locale.personalSignInButton}
        >
            {locale.personalSignInButton}
        </Link>
        {isEnvTruthy('COMPANY_TOGGLE') && (
            <Link
                className="btn btn-company-sign-in"
                to={companyAuthLink}
                aria-label={locale.companySignInButton}
            >
                {locale.companySignInButton}
            </Link>
        )}
    </>

    return (
        <div className='landing-element-container' id="landing-page-footer">
            <div className='landing-element-content mb-5'>
                <div className='landing-page-footer-container'>
                    <h1>{locale.title}</h1>
                    <p>{locale.subtitle}</p>
                    <div className='flex-column gap-2 mt-4 d-flex mb-5'>
                        {signInButtonsElement}
                    </div>
                </div>
                <Logo color='rgba(255, 255, 255, 0.2)' width='100%' ariaLabel='MyRopo logo' />
            </div>
            <Footer />
        </div>
    )
}

LandingFooter.propTypes = {
    locale: PropTypes.object.isRequired
}

export default LandingFooter;
